export const woolPantsPhotos = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/maKAP3eRZFoDzKi4pzTeG2/Зображення_65.jpg',
    alt: 'Шоколадні шерстяні штани палаццо на моделі',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/82rP4KSqvYB1Ma1TG9AhbM/Зображення_14.jpg',
    alt: 'Шерстяні штани палаццо кольору капучино',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tZaQ9qwik7QVu9nN7MhEFf/Зображення_15.jpg',
    alt: 'Шерстяні штани палаццо кольору бежевий меланж',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/eUvqCjjq7UekZ8f3pb7HJD/Зображення_18.jpg',
    alt: 'Графітові шерстяні штани палаццо',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2mDBjHBQCr4YFXcwu6iCEe/Зображення_64.jpg',
    alt: 'Шоколадні шерстяні штани палаццо — вигляд ззаду',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gfMoE72o7LWVrePeV37uEd/Зображення_16.jpg',
    alt: 'Деталь посадки шерстяних штанів палаццо кольору капучино',
  },
]

export const woolPantsColors = [
  'Шоколадний',
  'Капучино',
  'Бежевий меланж',
  'Графітовий',
]
